import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { Card, Box } from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AjaxHelper from "../../apis/apiRequest";
import { Endpoint, Status } from "../../apis/apiConstants";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { useDispatch } from "react-redux";
import { Image } from "react-bootstrap";
import placeholderBanner from "../../assets/Memon_Story.png";
import "./singleStories.scss";
import { errorSnackbar } from "../../actions/snackbarActions";
import { reactQuillFormats } from "../../constants/constants.quill";

const SingleStories = () => {
  const { state } = useLocation();
  const [story, setStory] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    getStory(state._id);
  }, []);

  const getStory = (id) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, `${Endpoint.GET_STORIES}/${id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          console.log(response.data.data);
          setStory(response.data.data);
        } else {
          dispatch(errorSnackbar("Error while fetching Story."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while fetching Story."));
      });
  };

  return (
    <Box>
      <Card className="singleStoryViewCard">
        <Box>
          <Image
            src={story.imgUrl ?? placeholderBanner}
            alt="Uploaded"
            className="singleStoryViewImage"
          />
          <Box className="singleStoryViewHeadline">{story.headline}</Box>
          <ReactQuill
            className="singleStoryViewReactquill"
            value={story.blog}
            modules={{
              toolbar: false,
            }}
            formats={reactQuillFormats}
            readOnly
          />
        </Box>
      </Card>
    </Box>
  );
};

export default SingleStories;
